export const SET_SELECTED_PLACE = "SET_SELECTED_PLACE";
export const RESET_SELECTED_PLACE = "RESET_SELECTED_PLACE";
export const SET_DIRECTIONS = "SET_DIRECTIONS";
